function checkSMSFactory(ctrl, UserService) {
	return function (smsCode) {
		UserService.checkForgotPasswordSMS(smsCode).then(function () {
			ctrl.$state.go('forgotPassword.successChange');
		}).catch(function () {
			ctrl.smsForm.smsCode.$setValidity('unexpectedError', false);
		});
	};
}

export default checkSMSFactory;
